var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import { range } from 'ramda';
import Input from '../../components/Input';
import Select from '../../components/Select';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import number from '../../lib/WithValidation/rules/number';
import PropTypes from 'prop-types';
import Icon from '../../components/Icon';
import translate from '../../lib/utils/translate';

var ContactInfo = function (_Component) {
  _inherits(ContactInfo, _Component);

  function ContactInfo(props) {
    _classCallCheck(this, ContactInfo);

    var _this = _possibleConstructorReturn(this, (ContactInfo.__proto__ || Object.getPrototypeOf(ContactInfo)).call(this, props));

    var currentYear = new Date().getFullYear();
    var yearRange = range(currentYear - 100, currentYear - 17).reverse().map(function (year) {
      return { value: year, label: year };
    });
    var monthRange = range(1, 13).map(function (month) {
      return {
        value: month,
        label: month
      };
    });
    var dayRange = range(1, 32).map(function (day) {
      return { value: day, label: day };
    });
    _this.state = {
      yearRange: yearRange,
      monthRange: monthRange,
      dayRange: dayRange,
      FirstName: props.FirstName,
      LastName: props.LastName,
      Address1: props.Address1,
      Zip: props.Zip,
      City: props.City,
      Country: props.Country,
      Currency: props.Currency,
      Gender: props.Gender
    };
    return _this;
  }

  _createClass(ContactInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          _onChange = _props.onChange,
          _onBlur = _props.onBlur,
          onSubmit = _props.onSubmit,
          intl = _props.intl,
          countries = _props.countries,
          currency = _props.currency,
          ipCountry = _props.ipCountry,
          onGoBack = _props.onGoBack,
          showLabel = _props.showLabel,
          showPlaceholder = _props.showPlaceholder,
          _props$autoFocus = _props.autoFocus,
          autoFocus = _props$autoFocus === undefined ? true : _props$autoFocus;
      var _state = this.state,
          yearRange = _state.yearRange,
          monthRange = _state.monthRange,
          dayRange = _state.dayRange,
          FirstName = _state.FirstName,
          LastName = _state.LastName,
          Address1 = _state.Address1,
          Zip = _state.Zip,
          City = _state.City,
          Country = _state.Country,
          Currency = _state.Currency;


      return React.createElement(
        'form',
        { className: 'Step2 form signup-form', onSubmit: onSubmit },
        React.createElement(
          'div',
          { className: 'layout-item' },
          React.createElement(Input, {
            className: 'layout-item-6',
            placeholder: showPlaceholder && translate({ id: 'label.first_name' }, intl),
            title: showLabel && translate({ id: 'label.first_name' }, intl),
            name: 'FirstName',
            autoFocus: autoFocus,
            value: FirstName,
            onBlur: function onBlur(value) {
              return _onBlur('FirstName', value);
            },
            error: errors.FirstName && translate({ id: errors.FirstName }, intl)
          }),
          React.createElement(Input, {
            className: 'layout-item-6',
            placeholder: showPlaceholder && translate({ id: 'label.last_name' }, intl),
            title: showLabel && translate({ id: 'label.last_name' }, intl),
            name: 'LastName',
            value: LastName,
            onBlur: function onBlur(value) {
              return _onBlur('LastName', value);
            },
            error: errors.LastName && translate({ id: errors.LastName }, intl)
          })
        ),
        React.createElement(Input, {
          placeholder: showPlaceholder && translate({ id: 'label.address' }, intl),
          title: showLabel && translate({ id: 'label.address' }, intl),
          className: 'layout-item',
          name: 'Address1',
          value: Address1,
          onBlur: function onBlur(value) {
            return _onBlur('Address1', value);
          },
          error: errors.Address1 && translate({ id: errors.Address1 }, intl)
        }),
        React.createElement(
          'div',
          { className: 'layout-item' },
          React.createElement(Input, {
            className: 'layout-item-6',
            placeholder: showPlaceholder && translate({ id: 'label.zip' }, intl),
            title: showLabel && translate({ id: 'label.zip' }, intl),
            name: 'Zip',
            value: Zip,
            onBlur: function onBlur(value) {
              return _onBlur('Zip', value);
            },
            error: errors.Zip && translate({ id: errors.Zip }, intl)
          }),
          React.createElement(Input, {
            className: 'layout-item-6',
            placeholder: showPlaceholder && translate({ id: 'label.city' }, intl),
            title: showLabel && translate({ id: 'label.city' }, intl),
            name: 'City',
            value: City,
            onBlur: function onBlur(value) {
              return _onBlur('City', value);
            },
            error: errors.City && translate({ id: errors.City }, intl)
          })
        ),
        React.createElement(
          'div',
          { className: 'layout-item' },
          React.createElement(Select, {
            className: 'layout-item-6',
            title: translate({ id: 'label.country' }, intl),
            options: countries && countries.value,
            name: 'Country',
            value: Country,
            onBlur: function onBlur(value) {
              return _onBlur('Country', value);
            },
            error: errors.Country && translate({ id: errors.Country }, intl),
            onChange: function onChange(event) {
              var value = event;

              if (event.currentTarget) value = event.currentTarget.value;

              return _onChange('Country', value);
            },
            defaultValue: ipCountry ? ipCountry.value : null
          }),
          React.createElement(Select, {
            className: 'layout-item-6',
            title: translate({ id: 'label.currency' }, intl),
            options: currency && currency.value,
            name: 'Currency',
            value: Currency,
            onBlur: function onBlur(value) {
              return _onBlur('Currency', value);
            },
            error: errors.Currency && translate({ id: errors.Currency }, intl),
            onChange: function onChange(event) {
              var value = event;

              if (event.currentTarget) value = event.currentTarget.value;

              return _onChange('Currency', value);
            },
            defaultValue: ipCountry ? ipCountry.currency : null
          })
        ),
        React.createElement(
          'div',
          { className: 'layout-item' },
          React.createElement(Select, {
            defaultOptionLabel: showPlaceholder && translate({
              id: 'label.year-placeholder'
            }, intl),
            className: 'layout-item-4',
            title: showLabel && translate({ id: 'label.year' }, intl),
            options: yearRange,
            name: 'year_of_birth',
            placeholder: showPlaceholder && translate({ id: 'label.year' }, intl),
            onBlur: function onBlur(value) {
              return _onBlur('year_of_birth', value);
            }
          }),
          React.createElement(Select, {
            defaultOptionLabel: showPlaceholder && translate({
              id: 'label.month-placeholder'
            }, intl),
            className: 'layout-item-4 month-input',
            title: showLabel && translate({ id: 'label.month' }, intl),
            options: monthRange,
            name: 'month_of_birth',
            placeholder: showPlaceholder && translate({ id: 'label.month' }, intl),
            onBlur: function onBlur(value) {
              return _onBlur('month_of_birth', value);
            }
          }),
          React.createElement(Select, {
            defaultOptionLabel: showPlaceholder && translate({
              id: 'label.day-placeholder'
            }, intl),
            className: 'layout-item-4',
            title: showLabel && translate({ id: 'label.day' }, intl),
            options: dayRange,
            name: 'day_of_birth',
            placeholder: showPlaceholder && translate({ id: 'label.day' }, intl),
            onBlur: function onBlur(value) {
              return _onBlur('day_of_birth', value);
            }
          }),
          React.createElement(
            'span',
            { className: 'error-message' },
            (errors.year_of_birth || errors.month_of_birth || errors.day_of_birth) && translate({
              id: errors.year_of_birth || errors.month_of_birth || errors.day_of_birth
            }, intl)
          )
        ),
        React.createElement(Select, {
          title: translate({ id: 'label.gender' }, intl),
          options: ['Male', 'Female'].map(function (g) {
            return {
              value: g,
              label: translate({ id: 'noun.' + g }, intl)
            };
          }),
          name: 'Gender',
          onBlur: function onBlur(value) {
            return _onBlur('Gender', value);
          },
          error: errors.Gender && translate({ id: errors.Gender }, intl),
          onChange: function onChange(event) {
            var value = event;

            if (event.currentTarget) value = event.currentTarget.value;

            return _onChange('Gender', value);
          },
          defaultValue: 'Male'
        }),
        React.createElement(Input, {
          type: 'checkbox',
          label: intl.formatMessage({ id: 'label.terms-of-conditions' }),
          name: 'AcceptTerms',
          onChange: function onChange(e, name, val) {
            return _onChange(name, val);
          },
          error: errors.AcceptTerms && translate({ id: errors.AcceptTerms }, intl)
        }),
        React.createElement(Input, {
          type: 'checkbox',
          label: intl.formatMessage({
            id: 'label.optin.marketing',
            defaultMessage: 'I want to receive marketing material'
          }),
          name: 'optins',
          onChange: function onChange(e, name, val) {
            return _onChange(name, val);
          }
        }),
        React.createElement('input', {
          type: 'hidden',
          name: 'Language',
          value: this.props.locale.includes('-') ? this.props.locale.split('-')[0] : this.props.locale
        }),
        React.createElement(
          'div',
          { className: 'layout-item buttons' },
          React.createElement(
            'div',
            { className: 'backButton layout-item-6' },
            React.createElement(Icon, { icon: 'angle-left' }),
            React.createElement(
              'a',
              { type: 'button', className: 'wide', onClick: onGoBack },
              translate({ id: 'action.button.previous' }, intl)
            )
          ),
          React.createElement(
            'div',
            { className: 'layout-item-6' },
            React.createElement(
              'button',
              { className: 'button primary wide', type: 'submit' },
              translate({ id: 'action.button.continue' }, intl)
            )
          )
        )
      );
    }
  }]);

  return ContactInfo;
}(Component);

ContactInfo.propTypes = {
  /** Validation error messages */
  errors: PropTypes.object,
  /** Listens for value changes */
  onChange: PropTypes.func,
  /** When user moves focus from input field */
  onBlur: PropTypes.func,
  /** Submits the form */
  onSubmit: PropTypes.func,
  /** internationalize object giving all its properties */
  intl: PropTypes.object,
  /** Contries from contentful config */
  countries: PropTypes.object,
  /** Currencies from contentful config */
  currency: PropTypes.object,
  /** Data about current country based on IP */
  ipCountry: PropTypes.object,
  /** Goes back one step in the signup process */
  onGoBack: PropTypes.func,
  /** optional boolean to show label above input fields */
  showLabel: PropTypes.bool,
  /** optional boolean to show placeholder inside input fields */
  showPlaceholder: PropTypes.bool
};


var rules = {
  FirstName: [[require, 'error.empty.FirstName']],
  LastName: [[require, 'error.empty.surname']],
  Address1: [[require, 'error.empty.address']],
  Zip: [[require, 'error.empty.zip']],
  City: [[require, 'error.empty.city']],
  Country: [[require, 'error.empty.country']],
  Currency: [[require, 'error.empty.currency']],
  year_of_birth: [[require, 'error.empty.year'], [number, 'error.empty.year']],
  month_of_birth: [[require, 'error.empty.month'], [number, 'error.empty.month']],
  day_of_birth: [[require, 'error.empty.day'], [number, 'error.empty.day']],
  Gender: [[require, 'error.empty.gender']],
  Language: [[require, 'error.empty.language']],
  AcceptTerms: [[require, 'error.empty.terms-of-conditions']],
  optins: []
};

export default compose(WithValidation(rules), injectIntl)(ContactInfo);